/** @jsxRuntime classic */
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'proxy-polyfill'
// IE11 needs "jsxRuntime classic" for this initial file which means that "React" needs to be in scope
// https://github.com/facebook/create-react-app/issues/9906
import * as React from 'react'
import {hydrateRoot} from 'react-dom/client'

import App from './App'

// ReactDOM.render(<App />, document.getElementById('root'));
// createRoot(<App/>, document.getElementById('root'))
hydrateRoot(document.querySelector('#root') as Element, <App/>)
